import React, { Fragment } from 'react';
import ReactDOM from 'react-dom';
import Navbar from './components/Navbar/Navbar';
import TypeIt from 'typeit-react'
import ContactForm from './components/ContactForm/ContactForm'
import Particles from 'react-particles-js';
import 'bootstrap/dist/css/bootstrap.css';
import Carousel from 'react-bootstrap/Carousel'
import { initializeApp } from "firebase/app";
import { getDatabase, ref, onValue} from "firebase/database";
import CarouselItem from 'react-bootstrap/esm/CarouselItem';
import './index.css';
import Socialbar from './components/Social/Socialbar'

const firebaseConfig = {
    apiKey: "AIzaSyBUiFO9anSm02yGQA5JnTe1-Y732hJ3Ing",
    authDomain: "personal-website-bb3dc.firebaseapp.com",
    databaseURL: "https://personal-website-bb3dc-default-rtdb.europe-west1.firebasedatabase.app",
    projectId: "personal-website-bb3dc",
    storageBucket: "personal-website-bb3dc.appspot.com",
    messagingSenderId: "351016613547",
    appId: "1:351016613547:web:685ffe991ea60eb27569ee"
  };

initializeApp(firebaseConfig);
const db = getDatabase();

class App extends React.Component {
    render(){
        return(
            <Fragment>
                <Navbar/>
                <Home/>
                <About/>
                <Portfolio/>
                <Contact/>
                <Socialbar/>
            </Fragment>
        )
    }
}

function Type(instance, text)
{
    instance.type(text)
    .pause(750)
    .delete();
}

function Home()
{
    return(
        <div id = "home">
            <Particles
            className="particle"
            params={{
            "particles": {
            "number": {
            "value": 50},
            "size": {
            "value": 3}},
            "interactivity": {
            "events": {
            "onhover": {
            "enable": false,
            "mode": "repulse"
            }}}}} />

            <div className = "content">
                <h1>jelleMulyadi =
                <TypeIt
                    options = {{loop: true}}
                    getBeforeInit=
                    {
                        (instance) => 
                            {
                                var titleArray = [
                                    '"Aspiring software engineer"',
                                    '"M.Sc. Computer Science"',
                                    '"Algorithms enthusiast"',
                                    '"Problem solver"',
                                    '"Technology nerd"',
                                ]
                                titleArray.forEach(element => Type(instance, element));
                                return instance;
                            }
                    }                                
                />
                </h1>
            </div>
        </div>
    )
}

class About extends React.Component
{
    constructor(props)
    {
        super(props);
        this.state = {text: '', image: '', time: '', title: '', id: '', experience: []};
        const dbRef = ref(db, 'About me');
        onValue(dbRef, (snapshot) => {
            const data = snapshot.val();
            this.setState({text: data.text, title: data.title, image: data.image, time: data.time, id: data.id});
        });

        const expRef = ref(db, 'Experience');
        onValue(expRef, (snapshot) => {
            const data = Object.values(snapshot.val());
            this.setState({experience: data});
        });
    }

    componentDidUpdate()
    {
        let x = document.getElementsByClassName("exp-btn current")
        if(x.length === 0)
        {
            let y = document.getElementsByClassName("exp-btn");
            if(y.length !== 0)
            {
                y[0].click();
            }
        }
    }

    buttonClick(e, exp)
    {
        let x = document.getElementsByClassName("exp-field");        
        for(let i = 0; i < x.length; i++)
        {
            x[i].style.display = "none";
        }
        document.getElementById(exp.id).style.display = "block";

        let y = document.getElementsByClassName("exp-btn");
        for(let i = 0; i < y.length; i++)
        {
            y[i].className = "exp-btn";
        }
        e.target.className = "exp-btn current";
    }

    render()
    { 
        return(
            <div id = "about">
                <div className = "content">
                    <div>
                        <h1><span style={{color: "#32bcb0", display: "inline"}}>1.</span>About me</h1>
                        <h3>{this.state.text}</h3>
                    </div>
                    <div className="experience">
                        <div className="exp-btns">
                            {this.state.experience.map(exp =>
                                <button className="exp-btn" onClick={(e) => {
                                        this.buttonClick(e, exp);
                                    }}>
                                    {exp.name}
                                </button>
                            )}
                        </div>
                        <div className="exp-text">
                            {this.state.experience.map(exp =>
                                <h3 id={exp.id} className="exp-field" style={{display : 'none'}}>
                                    <h1>{exp.title}</h1> <br/>
                                    {exp.time} <br/><br/>
                                    {exp.text}
                                </h3>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

class Portfolio extends React.Component
{
    constructor(props)
    {
        super(props);
        this.state = {slides: []};
        const dbRef = ref(db, 'Portfolio');
        onValue(dbRef, (snapshot) => {
            const data = Object.values(snapshot.val());
            this.setState({slides: data});
        });
    }

    render()
    {
        return(
            <div id = "portfolio">
                <div className = "content">
                <h1><span style={{color: "#32bcb0", display: "inline"}}>2.</span>Projects</h1>
                    <Carousel interval={null}>
                    {this.state.slides.map(slide =>
                        <CarouselItem>
                            <h2 style={{color: "#32bcb0"}}>{slide.name}</h2>
                            <h3>{slide.text}</h3>
                            <h3>Technologies used: {slide.tech}</h3>
                                <a className = "slide-image" href={slide.link}>
                                    <div className= "image-cover" style={{width: slide.imgwidth}}>
                                        <img  src={slide.image} alt="project" style={{width: '100%', height:'100%'}}/>
                                    </div>
                                </a>
                            <a className = "slide-link" href={slide.link}><i className="fas fa-globe"></i></a>
                        </CarouselItem>
                    )}
                    </Carousel>
                </div>
            </div>
        );
    }
}

function Contact()
{
    return(
        <div id = "contact">
            <div className = "content">
                <h1><span style={{color: "#32bcb0", display: "inline"}}>3.</span>Let's connect!</h1>
                <h3>Want to work together or have any questions about me or my work? Feel free to contact me!</h3>
                <ContactForm/>
            </div>
        </div>
    );
}

ReactDOM.render(<App/>, document.getElementById('page'));